import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { REQUEST, deleteSegmentSuccess, deleteSegmentFailure } from '../../actions/segments/delete';
import { fetchRequest as fetchSegments } from '../../actions/segments/list';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';
import { Error as ErrorAction } from '../../actions/error/error';

// Worker saga for deleting a segment
function* deleteSegment(action) {
  try {
    // Get headers from the utility function
    const headers = getLocalUser();
    
    if (!headers.Authorization) {
      throw new Error('Authentication token not found');
    }
    
    // Make the DELETE request to delete the segment
    const response = yield call(
      axios.delete,
      `${config.API_URL}/segment/${action.payload}`,
      { headers }
    );
    
    // Dispatch success action with the response data
    yield put(deleteSegmentSuccess(response.data));
    
    // Add success snackbar message
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: 'Segment deleted successfully' });
    
    // Refresh the segments list to reflect the deletion
    yield put(fetchSegments({}));
    
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Delete segment saga error:', error);

    const errorMessage = error?.response?.status === 404
      ? `Segment with ID ${action.payload} not found or you don't have permission to delete it`
      : extractErrorMessage(error);

    yield put(ErrorAction(error));
    yield put(deleteSegmentFailure(errorMessage));
    
    return {
      success: false,
      error: errorMessage
    };
  }
}

// Watcher saga for segment deletion
export function* watch() {
  yield takeLatest(REQUEST, deleteSegment);
} 